import axiosInstance from "./AxiosInstance";

export function removeFvourite(candidate_ids) {
  const data = { candidate_ids };
  return axiosInstance.post("editor/candidates/favorites/remove", data);
}
